import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/utils/Button";
import simSwapAction from '../../redux/swap/actions';
import { useDispatch, useSelector } from "react-redux";
import ToastAlert from "../../components/utils/ToastAlert";
import CardLayout from "../../components/utils/CardLayout";
import authActions from "../../redux/auth/actions";

const { simswap, resetMessage } = simSwapAction;
const {  getUserDataByToken} = authActions;

const SIMSwap = () => {
  const dispatch = useDispatch();
  const { simSwapMessage, simSwapLoading, simSwapError, } = useSelector((state) => state.swap);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      msisdn: "", oldSerialNumber: "", newSerialNumber: "",
    },
  });

  useEffect(() => {
    return(() => {
      dispatch(resetMessage());
    })
  }, [])
  const onSubmit = (data) => {
    dispatch(simswap({
      data: {
        msisdn: data?.msisdn,
        newSerialNumber: data?.newSerialNumber,
        oldSerialNumber: data?.oldSerialNumber,
      },
    }));
  };

  const handleReset = () => { reset(); dispatch(resetMessage()) };
  useEffect(() => {
    if(simSwapMessage) {
      ToastAlert({
        type: "success",
        text: simSwapMessage,
      });
      handleReset();
      dispatch(getUserDataByToken());
    }
    if(simSwapError) {
      ToastAlert({
        type: "error",
        text: simSwapError,
      })
    }
  }, [simSwapMessage, simSwapError])
  return (
    <CardLayout title={<> SIM Swap</>} icon="fas fa-sync-alt " >
      <div className="row">
        <div className="col-lg-12">
          <form onSubmit={handleSubmit(onSubmit)} noValidate >
            <div className="row">
              <div className="col-lg-3 mb-2" >
                <label className="form-label fw-semibold">
                  MSISDN <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.msisdn ? "is-invalid" : ""}`}
                  placeholder="MSISDN"
                    maxLength={10}
                  {...register("msisdn", {
                    required: "MSISDN is required",
                  })}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, "");
                  }}
                />
                <div className="invalid-feedback"> {errors.msisdn?.message} </div>
              </div>
              <div className="col-lg-3 mb-2">
                <label className="form-label fw-semibold">
                  Old Serial Number <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.oldSerialNumber ? "is-invalid" : ""}`}
                  placeholder="Old Serial Number"
                  {...register("oldSerialNumber", {
                    required: "Old serial number is required",
                    pattern: {
                      value: /^[0-9]{18,20}$/,
                      message: "Enter 18–20 digits",
                    },
                  })}
                    onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/\D/g, "")
                      
                      .slice(0, 20);
                  }}
                />
                <div className="invalid-feedback"> {errors.oldSerialNumber?.message} </div>
              </div>
              <div className="col-lg-3 mb-2" >
                <label className="form-label fw-semibold">
                  New Serial Number <span className="text-danger">*</span>
                </label>
                <input type="text" className={`form-control ${errors.newSerialNumber ? "is-invalid" : ""}`}
                  placeholder="New Serial Number" {...register("newSerialNumber",
                    {
                      required: "New serial number is required", pattern: {
                         value: /^[0-9]{18,20}$/,
                        message: "Enter 18–20 digits",
                      },
                    })}
                  onInput={(e) => { e.target.value = e.target.value .replace(/\D/g, "") .slice(0, 20); }}
                  />
                <div className="invalid-feedback"> {errors.newSerialNumber?.message} </div>
              </div>
              <div className="col-md-3 d-flex align-items-end" style={{ height: '70px' }}>
                <div className="d-flex gap-3">
                  <Button
                    title={simSwapLoading ? 'Processing...' : "Swap SIM "}
                    buttonType="submit"
                    variant="primary"
                    disabled={simSwapLoading}
                    icon={<i className="fas fa-exchange-alt menu-icon me-2"></i>}
                  />
                  <Button
                    title="Reset"
                    buttonType="button"
                    variant="secondary"
                    icon={<i className="ri-refresh-line me-2"></i>}
                    onClick={handleReset}
                  />
                </div>
              </div>

            </div>
          </form>
        </div>
      </div>
    </CardLayout>
  );
};

export default SIMSwap;
